/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LogDto } from '../../models/log-dto';
import { PageInfoDto } from '../../models/page-info-dto';

export interface UserControllerFindLogs$Params {
  id: string;

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 모델명 목록
 */
  modelNames?: Array<'Admin' | 'Auth' | 'Banner' | 'Breed' | 'CountryCode' | 'Faq' | 'Farm' | 'Favorite' | 'File' | 'GrowthGallery' | 'GrowthHistory' | 'Inquiry' | 'Log' | 'Notice' | 'NotificationBatch' | 'Notification' | 'Order' | 'Pig' | 'Shipment' | 'Popup' | 'Post' | 'PostComment' | 'PostLike' | 'PostBlock' | 'Product' | 'Setting' | 'Settlement' | 'SettlementDetail' | 'ShopOrder' | 'ShopOrderItem' | 'ShopPayment' | 'ShopProduct' | 'ShopProductOption' | 'Terms' | 'User' | 'UserStatusHistory' | 'Visitor'>;

/**
 * 모델 ID
 */
  modelIds?: Array<string>;
}

export function userControllerFindLogs(http: HttpClient, rootUrl: string, params: UserControllerFindLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<LogDto>;
'pageInfo': PageInfoDto;
}>> {
  const rb = new RequestBuilder(rootUrl, userControllerFindLogs.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('modelNames', params.modelNames, {});
    rb.query('modelIds', params.modelIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'items': Array<LogDto>;
      'pageInfo': PageInfoDto;
      }>;
    })
  );
}

userControllerFindLogs.PATH = '/api/user/{id}/logs';
